export function extractJsonFieldSql(field: string, path: string, ifNull?: string): string {
    if (ifNull !== undefined) {
        return `ifnull(json_extract(${field}, '${path}'), ${ifNull})`;
    }
    return `json_extract(${field}, '${path}')`;
}

/*

export function extractJsonFieldSql(field: string, path: string, ifNull?: string): string {
    if (ifNull !== undefined) {
        return `ifnull(
case
when json_valid(json_extract(${field}, '${path}'))
then json_extract(${field}, '${path}')
when json_extract(${field}, '${path}') is null then null
else json_array(json_extract(${field}, '${path}'))
end,
${ifNull}
)`;
    }
    return `case
when json_valid(json_extract(${field}, '${path}'))
then json_extract(${field}, '${path}')
when json_extract(${field}, '${path}') is null then null
else json_array(json_extract(${field}, '${path}'))
end`;
}
*/
